module.exports = __webpack_public_path__ + "img/DISHWASHER_AMENITY.c8d9d13d.svg";